var t = /[\[\]\/\\:*?]+/;
function n(e) {
  if (!e)
    throw new Error("Sheet name can't be empty");
  if (e.length > 31)
    throw new Error('Sheet name "'.concat(e, `" can't be longer than 31 characters`));
  if (t.test(e))
    throw new Error('Sheet name "'.concat(e, '" contains illegal characters: []/\\:*?'));
}
export {
  n as default
};
//# sourceMappingURL=index.es478.js.map
